import "../styles/CoursePage.css";
import { courseCatalog } from "../data/courseDetails";
import CourseCard from "./CourseCard";

const CoursePage = ({ navigate }) => {
  const goToCourse = (slug) => navigate(`/courses/${slug}`);

  return (
    <section id="courses-page" className="courses-page-section">
      <h2 className="courses-page-heading">Our Courses</h2>
      <p className="courses-page-sub">Industry-ready programs with hands-on projects and placement support.</p>

      <div className="courses-page-grid">
        {courseCatalog.map((course) => (
          <CourseCard
            key={course.slug}
            course={course}
            navigate={navigate}
            onEnroll={goToCourse}
          />
        ))}
      </div>
    </section>
  );
};

export default CoursePage;
